import { CMS_SLUGS } from 'src/constants'

export const queryKeys = {
  cms: {
    homePage: () => ['cms', CMS_SLUGS.home_page] as const,
    benefits: () => ['cms', CMS_SLUGS.benefits] as const,
    daysOff: () => ['cms', CMS_SLUGS.days_off_page] as const,
    onboarding: () => ['cms', CMS_SLUGS.onboarding] as const,
    resources: () => ['cms', CMS_SLUGS.resources] as const,
    thankYou: () => ['cms', CMS_SLUGS.thankYou] as const,
    quickAccess: () => ['cms', CMS_SLUGS.quickAccess] as const,
    workTools: () => ['cms', CMS_SLUGS.workTools] as const,
    newsletters: () => ['cms', CMS_SLUGS.newsletters] as const,
    newsAll: () => ['cms', CMS_SLUGS.news] as const,
    news: (filter: string) => ['cms', CMS_SLUGS.news, filter] as const,
    newsCategories: () => ['cms', CMS_SLUGS.newsCategories] as const,
    resourcePage: (slug: string) =>
      ['cms', CMS_SLUGS.resourcePageSlug, slug] as const,
    onboardingPage: (slug: string) =>
      ['cms', CMS_SLUGS.onboardingSlug, slug] as const,
    policiesCategories: () => ['cms', CMS_SLUGS.policiesCategories] as const,
    policies: (category: string, search: string) =>
      ['cms', CMS_SLUGS.policies, category, search] as const,
    spotlightCategories: () =>
      ['cms', CMS_SLUGS.peopleSpotlightCategories] as const,
    spotlight: (id: string) => ['cms', CMS_SLUGS.peopleSpotlights, id] as const,
    motivationalMessages: () => ['cms', CMS_SLUGS.motivationalMessage] as const,
    workingHours: () => ['cms', CMS_SLUGS.workingHours] as const,
    search: (query: string) => ['cms', 'search', query] as const
  }
} satisfies Record<
  string,
  Record<string, (...args: never[]) => readonly unknown[]>
>
